import { isNil } from "lodash/fp"
import log from "loglevel"
import { inspect } from "./inspect"
import { httpRequest } from "../../functions/common"
import { format } from 'date-fns/fp'

log.setLevel(log.levels.DEBUG)

const env = process.env['REACT_APP_ENV'] ?? 'dev'


const baseName = 'miraiz-connect.jp'
const zoneName = `${{ prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
    }${baseName}`
const domainName = `webhook${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
    }.tsunagu-series.${zoneName}`

export const sendRequestData = async (token: string, campaignCode: string): Promise<boolean> => {
    const timeStamp = format('yyyy-MM-dd HH:mm:ss')(new Date())
    const result = await httpRequest('POST', `https://${domainName}/v1/tcidauth/campaign/request/${campaignCode}`,
        { token, timeStamp },
        { Authorization: `Bearer ${token}` })
    if (isNil(result) || result.status !== 200) {
        log.error(`[functions.sendRequestData]`, inspect(result))
        return false
    }
    return true
}

export const hasExeededUsageLimitApi = async (token: string, campaignCode: string): Promise<boolean | undefined> => {
    const result: {
        status: number
        data: {
            success: boolean
            result: boolean
        } | undefined
    } | undefined = await httpRequest('GET', `https://${domainName}/v1/tcidauth/coupon/useage-limit/${campaignCode}`,
        undefined,
        { Authorization: `Bearer ${token}` })
    if (isNil(result) || result.status !== 200 || isNil(result.data) || !result.data.success) {
        log.error(`[functions.hasExeededUsageLimitApi]`, inspect(result))
        return undefined
    }
    return result.data.result
}

export const isAlreadyRequestedApi = async (token: string, campaignCode: string): Promise<boolean | undefined> => {
    const result: {
        status: number
        data: {
            success: boolean
            result: boolean
        } | undefined
    } | undefined = await httpRequest('POST', `https://${domainName}/v1/tcidauth/requested/${campaignCode}`,
        { token },
        { Authorization: `Bearer ${token}` })
    if (isNil(result) || result.status !== 200 || isNil(result.data) || !result.data.success) {
        log.error(`[functions.isAlreadyRequestedApi]`, inspect(result))
        return undefined
    }
    return result.data.result
}

// export const isRegisteredKateneApi = async (token: string): Promise<boolean | undefined> => {
//   const result: {
//     status: number
//     data: {
//       success: boolean
//       result: boolean
//     } | undefined
//   } | undefined = await httpRequest('POST', `https://${domainName}/v1/tcidauth/isRegisteredKatene`,
//     {},
//     { Authorization: `Bearer ${token}` })
//   if (isNil(result) || result.status !== 200 || isNil(result.data) || !result.data.success) {
//     log.error(`[functions.isRegisteredKateneApi]`, inspect(result))
//     return undefined
//   }
//   return result.data.result
// }
